import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "dashboard", "dashboardFilters", "frequency", "frequencyUseFiscalYear", "report", "widget"];
import { useContext, createContext } from 'react';
// @ts-expect-error untyped dependency
import { getLayoutV2 } from 'dashboard-lib/public/widget/widget-schema';
import useNormalizedReport from 'dashboard-ui-components/lib/useNormalizedReport';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultWidgetContext = {
  dashboard: null,
  dashboardFilters: [],
  report: null,
  size: null,
  reportRefreshCount: 0
};
export const WidgetContext = /*#__PURE__*/createContext(defaultWidgetContext);
export const useWidgetContext = () => {
  return useContext(WidgetContext);
};
export const WidgetContextProvider = props => {
  const {
      children,
      dashboard,
      dashboardFilters,
      frequency,
      frequencyUseFiscalYear,
      report,
      widget
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    normalizedReport,
    isLoading: isNormalizationLoading
  } = useNormalizedReport(report);
  const hasNormalizationFailed = !normalizedReport && !isNormalizationLoading;
  if (!normalizedReport && !hasNormalizationFailed) {
    return null;
  }
  return /*#__PURE__*/_jsx(WidgetContext.Provider, {
    value: Object.assign({
      dashboard,
      dashboardFilters,
      // if normalization fails pass original report to PlatformReportResolver to render correct error message
      report: normalizedReport || report,
      size: getLayoutV2(widget),
      reportRefreshCount: widget.get('reportRefreshCount'),
      refreshing: widget.get('refreshing'),
      refreshError: widget.get('refreshError'),
      frequencyUseFiscalYear,
      frequency
    }, rest),
    children: children
  });
};